import {signOutSvg as Icon__small__signOutSvg} from '../Icon__small/Icon__small--signOut.js'

export var signOut = {
  name: 'signOut',
  category: 'icon',
  colorable: true,
  svg: Icon__small__signOutSvg,
};
